import { render, staticRenderFns } from "./DeTextarea.vue?vue&type=template&id=9bad0530&"
import script from "./DeTextarea.vue?vue&type=script&lang=js&"
export * from "./DeTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports